import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

/** Dialog da Ouvidoria (PinPag e Banco Rendimento). */
@Component({
  selector: 'app-ombudsman-dialog',
  imports: [MatDialogTitle, MatDialogContent, MatDialogClose, MatIconButton],
  templateUrl: './ombudsman-dialog.html',
  styleUrl: '../privacy-policy-dialog/privacy-policy-dialog.scss',
})
export class OmbudsmanDialog {}
